import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const FilterContainer = styled.div`
  margin-top: 1rem;

  label {
    font-size: 1rem;
    color: var(--grey-100);
    font-family: DM Sans;
  }

  > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    margin-top: 0.5rem;
  }
`

type propButton = {
  isActive?: boolean
}

export const FilterButton = styled.button<propButton>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px;
  padding-left: 8px;
  cursor: pointer;
  font-family: DM Sans, sans-serif;
  font-size: 0.9rem;
  border-radius: 6px;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  transition: opacity 0.3s;
  background-color: var(--black-200);
  color: var(--white);

  ${({isActive}) => isActive && css`
    background-color: var(--primary);
    color: var(--black-100);
    font-weight: 600;
  `}

  &:hover {
    opacity: 0.8;
  }
`

export const FilterButtonValue = styled.span`
  background-color: var(--black-400);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: var(--white);
  padding: 0rem 0.4rem;
  margin-left: 0.4rem;
`